import styled from "styled-components"

const StyledCenterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  text-align: center;
`

export default StyledCenterContainer
